export default __webpack_public_path__ + "static/card-e39007d3f97b7ef1ec59b6a80590a729.png";